module.exports = __webpack_public_path__ + "9b5f97a5c589186bd4cc2d813b3025af.png";